var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-wizBlue"},[_c('div',{staticClass:"copyright-container d-flex align-items-center justify-content-between"},[_c('p',{staticClass:"text-white mb-0"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('VersionInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }